import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import { removeCTe, addCTe, updateCTe } from "../../../../features/manifestoSlice"
import { getUuidV4, handleNumberOnly, isNumber } from "../../../../utils/utils";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faSave, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { JConfirmDelete, MensagemModal } from "../../../../components/Components";
import { Link } from "react-router-dom";
import CTesProdutoPerigoso from "./CTesProdutoPerigoso";
import { infCTesInterface, infMunDescargaInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import CTesUnidadeTransp from "./CTesUnidadeTransp";

const initialForm: infCTesInterface = {
    chCTe: '',
    SegCodBarra: '',
    municipio_id: 0,
    name: '',
    indReentrega: false,
    peri: [],
    id: 0,
    infUnidTransp: [],
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

const CTes: React.FC = () => {
    const dispatch = useDispatch();
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const selectMunicipiosDescarregamento = useSelector((state: RootState) =>
        state.manifesto.selectMunicipiosDescarregamentos);
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const munCTeSelectRef = useRef<HTMLSelectElement>(null);
    const [notaConhecimento, setNotaConhecimento] = useState<infCTesInterface>(initialForm);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showProdutoPerigoso, setShowProdutoPerigoso] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [change, setChange] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        if (change) {
            alerta('Existem alterações não salvas.');
            return;
        }
        setSelected(value);
        setShowModal(true);
    }

    const handleUpdateCTe = () => {
        if (validaPreenchimentoCTe()) {
            dispatch(updateCTe({
                ...notaConhecimento,
                name: munCTeSelectRef.current?.options[munCTeSelectRef.current?.selectedIndex].text || ''
            }));
            setNotaConhecimento(initialForm);
            setChange(false);
            setShowProdutoPerigoso(false);
        }
    }

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCTeChange = (e: any) => {
        const { name, value } = e.target;
        setNotaConhecimento((prev) => ({ ...prev, [name]: value }));
    }

    const validaPreenchimentoCTe = () => {
        if (notaConhecimento.chCTe === "") {
            alerta('Informe uma chave CTe.');
            return false;
        }

        if (!isNumber(notaConhecimento.chCTe)) {
            alerta('Chave CT-e aceita somente números.');
            return false;
        }

        if (notaConhecimento.SegCodBarra?.trim() !== "") {
            if (!isNumber(notaConhecimento.SegCodBarra)) {
                alerta('Seg. Cod. Barras aceita somente números.');
                return false;
            }
        }

        if (notaConhecimento.chCTe.substring(20, 22) !== '57') {
            alerta('Chave informada não é uma CT-e.');
            return false;
        }

        if (notaConhecimento.chCTe.length !== 44) {
            alerta('Chave deve conter 44 caracteres.');
            return false;
        }

        if (munDescarga.flatMap((item: infMunDescargaInterface) => item.infCTe).find((item: infCTesInterface) =>
            item.chCTe === notaConhecimento.chCTe && item.id !== notaConhecimento.id)) {
            alerta('Chave já foi adicionada.');
            return false;
        }

        setMessageAlert('')
        setShowAlert(false)
        return true;
    }

    const handleRemover = (value: SelectObjectRemoveInterface) => {
        dispatch(removeCTe({ municipio_id: parseInt(value.id.toString()), chCTe: value.title }));
        setShowModal(false);
    }

    const handleAddCTe = () => {
        if (munCTeSelectRef.current && munCTeSelectRef.current?.value !== "") {
            const nomeMunicipio = munCTeSelectRef.current?.options[munCTeSelectRef.current?.selectedIndex].text || '';

            if (validaPreenchimentoCTe()) {

                dispatch(addCTe({
                    ...notaConhecimento,
                    id: getUuidV4(),
                    municipio_id: parseInt(munCTeSelectRef.current?.value),
                    name: nomeMunicipio,
                }));

                setNotaConhecimento(initialForm);
                setShowProdutoPerigoso(false);
            }

        } else {
            alerta('Selecione um município.');
            return;
        }
    }

    const loadCTe = (municipio_id: number, chCTe: string) => {
        if (change) {
            alerta('Existem alterações não salvas.');
            return;
        } else {
            const municipio = manifesto.infMunDescarga.find((item: any) => item.municipio_id === municipio_id);
            const nfe = municipio?.infCTe?.find((item: infCTesInterface) => item.chCTe === chCTe);
            setNotaConhecimento({ ...notaConhecimento, ...nfe, municipio_id: municipio_id, name: municipio?.name });
            setChange(true);
            if (nfe) {
                if (nfe.peri?.length > 0) {
                    setShowProdutoPerigoso(true);
                }
            }
        }
    }

    useEffect(() => {
        if (munDescarga?.length > 0) {
            setNotaConhecimento((prev) => (
                {
                    ...prev,
                    municipio_id: munDescarga[0].municipio_id
                }
            ))
        }
    }, [munDescarga]);

    return (<>

        <Row className="mb-3">
            <Col md>
                <Row className="g-2 mb-3">
                    <Col md={4}>
                        <Form.Group >
                            <Form.Label>*Municipios</Form.Label>
                            <Form.Select name="cte_municipio_id" value={notaConhecimento.municipio_id}
                                onChange={handleCTeChange} ref={munCTeSelectRef}>
                                {selectMunicipiosDescarregamento?.map((item: any) => {
                                    return (<option value={item.id}>{item.name}</option>);
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group >
                            <Form.Label>*Chave CT-e</Form.Label>
                            <Form.Control name="chCTe" value={notaConhecimento.chCTe}
                                onKeyUp={handleNumberOnly} type="text" onChange={handleCTeChange} />
                        </Form.Group>
                    </Col>

                </Row>
                <Row className="g-2 mb-3">
                    <Col md>
                        <Form.Group >
                            <Form.Label>Seg. Cod. Barras</Form.Label>
                            <Form.Control name="SegCodBarra" value={notaConhecimento.SegCodBarra}
                                onKeyUp={handleNumberOnly} type="text" onChange={handleCTeChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group controlId="active">
                            <Form.Switch className="mb-0" type="switch" name="active" label="ind. Reentrega?"
                                onChange={(e) =>
                                    setNotaConhecimento({ ...notaConhecimento, indReentrega: e.target.checked })}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group controlId="active">
                            <Form.Switch className="mb-0" type="switch" name="opcoes" label="+Opções"
                                checked={showProdutoPerigoso}
                                title="Adicionar informações de produto perigoso e unidades de transporte"
                                onChange={(e) => setShowProdutoPerigoso(e.target.checked)} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="g-2">
                    {change ? (<>
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="success" onClick={handleUpdateCTe}>
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </Button>
                        </Col>
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="secondary" onClick={() => {
                                setChange(false);
                                setShowProdutoPerigoso(false);
                                setNotaConhecimento(initialForm);
                            }}>
                                <FontAwesomeIcon icon={faXmark} /> Cancalar
                            </Button>
                        </Col>
                    </>) : (
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="primary" onClick={handleAddCTe}>
                                <FontAwesomeIcon icon={faPlus} /> Adicionar
                            </Button>
                        </Col>
                    )
                    }
                </Row>
            </Col>
            {showProdutoPerigoso && (

                <Col md={7} className="border-start">
                    <div className="nav nav-underline" id="v-pills-tab-produto-perigoso-cte" role="tablist">

                        <button className="nav-link active" id="tabpp1cte-tab" data-bs-toggle="pill"
                            data-bs-target="#tabpp1-cte" type="button" role="tab">
                            Produto Perigoso ONU (Opcional)
                        </button>

                        <button className="nav-link" id="tabpp2-cte-tab" data-bs-toggle="pill"
                            data-bs-target="#tabpp2-cte"
                            type="button" role="tab">Inf. Unidades de Transporte (Opcional)
                        </button>

                    </div>
                    <div className="tab-content pt-2 px-2" id="v-pills-tabContentpp-cte">
                        <div className="tab-pane fade show active" id="tabpp1-cte" role="tabpanel">
                            <CTesProdutoPerigoso notaFiscal={notaConhecimento} setNotaFiscal={setNotaConhecimento} />
                        </div>
                        <div className="tab-pane fade" id="tabpp2-cte" role="tabpanel" >
                            <CTesUnidadeTransp notaFiscal={notaConhecimento} setNotaFiscal={setNotaConhecimento} />
                        </div>
                    </div>
                </Col>
            )}

        </Row>

        <h6 className="my-3"><span className="text-dark">(10.000 no máximo)</span></h6>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '4rem' }}>#</th>
                    <th>Municipio</th>
                    <th>Chave CT-e</th>
                    <th>Seg. Cod. Barras</th>
                </tr>
            </thead>
            <tbody>
                {munDescarga?.map((item: infMunDescargaInterface) => (
                    <>
                        {item.infCTe?.map((cte: infCTesInterface) => {
                            return (
                                <tr key={item?.municipio_id}>
                                    <td className="d-flex justify-content-around ">
                                        <Link to={''} className="text-danger"
                                            onClick={() =>
                                                handleOpenModal({ id: item.municipio_id, title: cte?.chCTe })
                                            }
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Link>
                                        <Link to={''} className="text-success" title="Editar"
                                            onClick={() =>
                                                loadCTe(item.municipio_id, cte?.chCTe)
                                            }
                                        >
                                            <FontAwesomeIcon icon={faPencil} />
                                        </Link>
                                    </td>
                                    <td>{item?.name}</td>
                                    <td>{cte?.chCTe}</td>
                                    <td>{cte?.SegCodBarra}</td>
                                </tr>
                            )
                        })}
                    </>
                ))}
            </tbody>
        </Table>
        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected}
        />
        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default CTes;
